module.exports = "https://static.wmbcdn.com/uniweb/images/c772059800b350303af096407fd3a8a5.svg";